import { createAction, createActionGroup, props } from "@ngrx/store";

export const getPanelistPoints = createActionGroup({
    source: 'Dashboard',
    events: {
        'Load Panelist Points': props<{ status: 'request' | 'success' | 'error', data?: any, error?: any }>(),                     // triggers effect
    }
});
export const updatePanelistPointData = createAction(
    '[Panelist Point Data] Update Panelist Point Data',
    props<{ data: any }>()
);